import { Stack } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';

const CreditLine: React.FC = () => (
  <Stack
    sx={{
      flex: 1,
      minHeight: '100%',
    }}
  >
    <Outlet />
  </Stack>
);

export default CreditLine;
